<aside>
    <div class="p-2 m-2">
      <div>
        <app-branding-logo-display />
      </div>
      <div>
        <div class="text-uppercase border-bottom"><strong> {{userConfig?.name}} </strong></div>
        <div> {{userConfig?.division?.name}} </div>
      </div>
    </div>

    <div class="w-100 border-top border-dark-subtle">
      @if(userConfig?.generalFreightEnabled){
        <div class="nav-link text-uppercase border-bottom  bg-body-tertiary text-md-start" routerLink="/app/order/" routerLinkActive="nav-active"  (click)="openOrders()">
            <strong class="text-body-secondary">
                General Freight
            </strong>
        </div>
      }
      @if(userConfig?.specialisedFreightEnabled){
        <div class="nav-link text-uppercase border-bottom  bg-body-tertiary text-md-start" routerLink="/app/jobbing/" routerLinkActive="nav-active" (click)="openSpecialisedFreight()">
          <strong class="text-body-secondary">
              Specialised Freight
          </strong>
        </div>
      }
      @if(userConfig?.containersEnabled){
        <div class="nav-link text-uppercase border-bottom  bg-body-tertiary text-md-start" routerLink="/app/containers/" routerLinkActive="nav-active" (click)="openContainers()">
          <strong class="text-body-secondary">
              Containers
          </strong>
        </div>
      }
    </div>
</aside>
